import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

/**
 * Contains style information for the signature section.
 */
export const SignatureSectionStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    statusDot: {
        marginLeft: 8,
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: "#3aaa35",
    },
    pageWrapper: {
        position: "relative",
        height: "100%",

        [theme.breakpoints.up("md")]: {
            // backgroundColor: "#F9F9F9",
            padding: "30px",
            paddingLeft: "95px",
            height: "calc(100% - 51px)",
        },
        [theme.breakpoints.down("sm")]: {
            height: "calc(100% - 75px)",
            overflowX: "hidden",
            overflowY: "auto",
        },
        paddingBottom: "0",
    },
    isMobileworkspace: {
        paddingBottom: "0px",
    },
    signatureRow: {
        display: "grid",
        gridTemplateColumns: "2fr 1fr 1fr",
        gap: "20px",
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr 1fr",
        },
    },
    signatureCard: {
        borderRadius: "3px",
        background: "#ECECEC",
        boxShadow: "none",
        "& > button": {
            height: "100%",
            "& > div.MuiCardContent-root": {
                padding: "16px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
            },
        },
    },
    accordionCard: {
        "& > div > div": {
            padding: "0px",
        },
        "& .MuiCollapse-container": {
            margin: "0px",
        },
    },
    cardHead: {
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        "& > div > h4": {
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: "12px",
            color: "#191919",
            letterSpacing: "-0.15px",
        },
        "& > div > p": {
            fontSize: "14px",
            fontWeight: "bold",
            lineHeight: "12px",
            color: "#191919",
            letterSpacing: "-0.15px",
        },
    },
    navigateToArrow: {
        alignItems: "center",
        display: "flex",
        "& svg": {
            fill: "#3aaa35",
            height: "24px",
            width: "24px",
        },
    },
    contentRow: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
    },
    [theme.breakpoints.down("sm")]: {
        root: {
            "& .baseHeader": {
                margin: "0px",
            },
            "& .baseViewAccordionBlock": {
                padding: "20px 30px",
            },
        },
        accordionDetails: {
            padding: "10px 0",
        },
        signatureRow: {
            gridTemplateColumns: "1fr 1fr",
            gap: "15px",
        },
    },
    [theme.breakpoints.down("xs")]: {
        signatureRow: {
            gridTemplateColumns: " 1fr",
            gap: "8px",
        },
    },
}));
